// Shared content & imagery for Lighthouse Home Services

const u = (base, w = 1600) =>
  base.includes("?")
    ? `${base}&w=${w}&q=80&auto=format&fit=crop`
    : `${base}?w=${w}&q=80&auto=format&fit=crop`;

export const IMAGES = {
  heroFamily: "https://static.prod-images.emergentagent.com/jobs/16339cd4-99ec-4840-b151-e4c4f868770a/images/f3542e47d26cf56481147d2ba42f796c2d9c9b17d1d2e3f0ab584a12232207c9.jpeg",
  heroExplain: "https://static.prod-images.emergentagent.com/jobs/16339cd4-99ec-4840-b151-e4c4f868770a/images/6b0779310ccf9efaf78fd4d03ef7fe510e78d00c4516c0e677595662bf72a218.jpeg",
  aboutHero: "https://static.prod-images.emergentagent.com/jobs/16339cd4-99ec-4840-b151-e4c4f868770a/images/2784a51a8fe5d17c8f4777926f289be86cc742634bd679c15a2a1a2b05e8de4c.jpeg",
  massaveBadge: "https://customer-assets-0z36b82j.emergentagent.net/job_coastal-home-hvac/artifacts/qdmxbrii_images%20%281%29.jpeg",
  family2: u("https://images.unsplash.com/photo-1758687125973-ec9932a4245b"),
  lighthouse: "https://images.pexels.com/photos/34789759/pexels-photo-34789759.jpeg?auto=compress&cs=tinysrgb&dpr=2&w=1800",
  coastalHome: "https://images.pexels.com/photos/22485304/pexels-photo-22485304.jpeg?auto=compress&cs=tinysrgb&dpr=2&w=1400",
  interiorWindow: u("https://images.unsplash.com/photo-1583847268964-b28dc8f51f92"),
  interiorFire: u("https://images.unsplash.com/photo-1632829882891-5047ccc421bc"),
  interiorMirror: u("https://images.unsplash.com/photo-1631679706909-1844bbd07221"),
  sunlitSofa: u("https://images.unsplash.com/photo-1583329550487-0fa300a4cd1a"),
  technician: u("https://images.unsplash.com/photo-1660330589827-da8ab7dd3c02"),
  installWork: u("https://images.unsplash.com/photo-1590402494930-602f7f857294"),
  crew: "https://customer-assets-0z36b82j.emergentagent.net/job_coastal-home-hvac/artifacts/4x6kjkfq_Crew.png",
  acUnit: "https://images.unsplash.com/photo-1757219525975-03b5984bc6e8?crop=entropy&cs=srgb&fm=jpg&w=1400&q=80",
  filterRepair: "https://images.pexels.com/photos/34404157/pexels-photo-34404157.jpeg?auto=compress&cs=tinysrgb&dpr=2&w=1200",
  team1: "https://images.pexels.com/photos/37842959/pexels-photo-37842959.jpeg?auto=compress&cs=tinysrgb&dpr=2&w=800",
  team2: "https://images.pexels.com/photos/28442321/pexels-photo-28442321.jpeg?auto=compress&cs=tinysrgb&dpr=2&w=800",
  team3: u("https://images.unsplash.com/photo-1494790108377-be9c29b29330", 800),
};

export const LOGO = {
  light: "https://customer-assets-0z36b82j.emergentagent.net/job_coastal-home-hvac/artifacts/n8saj7rb_Logo%202%20Light.png",
  dark: "https://customer-assets-0z36b82j.emergentagent.net/job_coastal-home-hvac/artifacts/a0hj7ufd_Logo%202%20Dark.png",
  onNavy: "https://customer-assets-0z36b82j.emergentagent.net/job_coastal-home-hvac/artifacts/md5vj68v_Logo%20White.png",
};

export const STATS = [
  { value: "2021", label: "Serving MA since" },
  { value: "800+", label: "Projects completed" },
  { value: "3", label: "Dedicated crews" },
];

export const LANGUAGES = ["English", "Portuguese", "Spanish"];

export const CREDENTIALS = ["Mass Save® HPIN Partner", "Mitsubishi Diamond Contractor"];

export const STANDARDS = [
  { n: "01", title: "High-Quality Work, On Time", body: "We take pride in completing every project within the agreed timeframe — the best quality, without the delays." },
  { n: "02", title: "Clean & Tidy Job Sites", body: "We keep our work areas clean, organized, and respectful of your space from start to finish." },
  { n: "03", title: "Multilingual Team", body: "Our crews speak English, Portuguese, and Spanish — so communication is always clear and comfortable." },
  { n: "04", title: "Investment in Training & Tools", body: "We continually invest in the latest training and equipment to deliver the most efficient, modern solutions." },
];

export const CONTACT = {
  phone: "(978) 618-7059",
  phoneHref: "tel:+19786187059",
  email: "info@lighthousehomeservice.com",
  address: "Oxford, Massachusetts",
  area: "Serving homeowners throughout Massachusetts",
};

export const NAV = [
  { label: "Home", to: "/" },
  { label: "About", to: "/about" },
  { label: "Services", to: "/services" },
  { label: "Service Areas", to: "/service-areas" },
  { label: "Contact", to: "/contact" },
];

export const SERVICES = [
  {
    slug: "ductless-mini-splits",
    title: "Ductless Mini Splits",
    tag: "Room-by-room comfort",
    image: "https://customer-assets-0z36b82j.emergentagent.net/job_coastal-home-hvac/artifacts/i0pxlma0_Screenshot%202026-08-06%20at%204.06.06%E2%80%AFPM.png",
    overview:
      "Ductless mini splits deliver efficient, independent heating and cooling to individual rooms — no ductwork required.",
    benefits: [
      "No ductwork needed",
      "Individual room-by-room zoning",
      "Sleek, quiet indoor units",
      "Excellent energy efficiency",
    ],
    why: "Our clean, considerate installs make a mini split look like it was always meant to be there.",
  },
  {
    slug: "ducted-mini-splits",
    title: "Ducted Mini Splits",
    tag: "Whole-home, hidden comfort",
    image: "https://customer-assets-0z36b82j.emergentagent.net/job_coastal-home-hvac/artifacts/lhhu1gnh_down-net_http20260806-126-cq1gev.webp",
    overview:
      "Ducted mini split systems pair heat-pump efficiency with discreet, centralized air delivery through concealed ductwork.",
    benefits: [
      "Even, whole-home comfort",
      "Hidden air handlers and ducts",
      "High-efficiency heating & cooling",
      "Clean, minimal indoor footprint",
    ],
    why: "We design ducted layouts that disappear into your home while delivering consistent comfort.",
  },
  {
    slug: "central-heat-pumps",
    title: "Central Heat Pumps",
    tag: "All-electric, year-round",
    image: "https://customer-assets-0z36b82j.emergentagent.net/job_coastal-home-hvac/artifacts/6cfsgnfm_down-net_http20260806-261-emjoj9.webp",
    overview:
      "Central heat pumps heat and cool your entire home from a single high-efficiency, all-electric system.",
    benefits: [
      "Heating and cooling in one system",
      "Lower energy bills",
      "Mass Save rebate eligible",
      "Cleaner, all-electric comfort",
    ],
    why: "We size every central heat pump to your specific home — never a one-size-fits-all quote.",
  },
  {
    slug: "gas-furnaces",
    title: "Gas Furnaces",
    tag: "Dependable winter warmth",
    image: "https://customer-assets-0z36b82j.emergentagent.net/job_coastal-home-hvac/artifacts/nc9mfycf_Screenshot%202026-08-06%20at%203.59.29%E2%80%AFPM.webp",
    overview:
      "Modern, high-efficiency gas furnaces deliver reliable, powerful heat through the coldest New England winters.",
    benefits: [
      "Strong, fast heating",
      "High-efficiency operation",
      "Safe, code-compliant installs",
      "Right-sized for your home",
    ],
    why: "We install furnaces safely and cleanly, with honest recommendations on what your home truly needs.",
  },
  {
    slug: "heat-pump-water-heaters",
    title: "Heat Pump Water Heaters",
    tag: "Efficient hot water",
    image: "https://customer-assets-0z36b82j.emergentagent.net/job_coastal-home-hvac/artifacts/9wq4t7i2_CE69CAFE-6A91-4359-8947-F8B46E9ED183.webp",
    overview:
      "Heat pump water heaters use ambient heat to warm your water at a fraction of the energy of conventional units.",
    benefits: [
      "Up to 70% less energy use",
      "Lower monthly bills",
      "Rebate eligible",
      "Long-lasting and reliable",
    ],
    why: "A simple upgrade that quietly saves you money every single day.",
  },
  {
    slug: "coil-only-installations",
    title: "Coil-Only Installations",
    tag: "Targeted upgrades",
    image: "https://customer-assets-0z36b82j.emergentagent.net/job_coastal-home-hvac/artifacts/ix9429bz_Screenshot%202026-08-06%20at%203.58.40%E2%80%AFPM.png",
    overview:
      "Coil-only installations pair a new evaporator coil with your existing compatible system for a cost-effective upgrade.",
    benefits: [
      "Cost-effective improvement",
      "Works with compatible systems",
      "Improved efficiency",
      "Expert, precise installation",
    ],
    why: "When a full replacement isn't needed, we'll recommend the smart, honest option instead.",
  },
];

export const VALUES = [
  { n: "01", title: "Integrity", body: "We give honest recommendations and stand behind every install. If it isn't right for your home, we'll tell you." },
  { n: "02", title: "Family", body: "We're a family-owned business, and we treat every customer like a member of ours — before, during, and long after." },
  { n: "03", title: "Excellence", body: "Attention to detail and clean workmanship are non-negotiable. Pride shows in the smallest connections." },
  { n: "04", title: "Clear Communication", body: "You'll always know what's happening and why. No jargon, no surprises, no pressure." },
];

export const WHY = [
  { title: "Respect for every home", body: "Drop cloths, clean boots, and tidy job sites. We leave your space better than we found it." },
  { title: "Honest recommendations", body: "Right-sized systems and transparent pricing. We never sell you more than you need." },
  { title: "Reliability", body: "We show up when we say we will and follow through to the final walkthrough." },
  { title: "Long-term relationships", body: "Most of our work comes from neighbors referring neighbors. That trust is everything." },
];

export const PROJECTS = [
  { id: 1, title: "Ducted Heat Pump Retrofit", category: "Heat Pumps", location: "Worcester, MA", desc: "Full electric conversion for a 1920s colonial, keeping the historic character intact.", images: [IMAGES.technician, IMAGES.interiorFire, IMAGES.coastalHome] },
  { id: 2, title: "Three-Zone Mini Split", category: "Mini Splits", location: "Sturbridge, MA", desc: "Ductless comfort added to a finished attic and two bedrooms with zero ductwork.", images: [IMAGES.acUnit, IMAGES.interiorMirror] },
  { id: 3, title: "Whole-Home Central Air", category: "Central Air", location: "Shrewsbury, MA", desc: "Quiet, even cooling installed ahead of a New England heat wave.", images: [IMAGES.interiorWindow, IMAGES.sunlitSofa] },
  { id: 4, title: "Living Room Comfort Makeover", category: "Before & After", location: "Oxford, MA", desc: "An aging system replaced with a modern heat pump and smart thermostat.", images: [IMAGES.interiorFire, IMAGES.interiorWindow] },
  { id: 5, title: "Coastal Cottage Mini Split", category: "Mini Splits", location: "Cape Cod, MA", desc: "Low-profile units matched to the home's bright, airy interior.", images: [IMAGES.sunlitSofa, IMAGES.acUnit] },
  { id: 6, title: "High-Efficiency Heat Pump", category: "Heat Pumps", location: "Auburn, MA", desc: "Mass Save rebate-qualified install with a same-week final walkthrough.", images: [IMAGES.technician, IMAGES.coastalHome] },
];

export const PROJECT_FILTERS = ["All", "Heat Pumps", "Mini Splits", "Central Air", "Before & After"];

export const TESTIMONIALS = [
  { quote: "Very professional, explained everything, polite and clean. I cannot say enough good things about both technicians. Very happy customer!", name: "Shannon M.", place: "Massachusetts" },
  { quote: "Very pleasant, competent, and respectful of my home and me. Good crew!", name: "Jack & Ellen", place: "Massachusetts" },
  { quote: "Excellent. Smart, courteous, considerate, and took great care to make everything look nice and clean up afterward. They did an excellent job explaining how everything works. Thank you!", name: "The Freeman Family", place: "Massachusetts" },
];

export const SERVICE_REGIONS = [
  { name: "Worcester County", center: [42.27, -71.87], homes: "Oxford · Worcester · Auburn · Sturbridge" },
  { name: "Greater Boston", center: [42.36, -71.06], homes: "Boston · Newton · Framingham" },
  { name: "MetroWest", center: [42.30, -71.42], homes: "Shrewsbury · Marlborough · Natick" },
  { name: "Cape Cod", center: [41.68, -70.30], homes: "Barnstable · Falmouth · Sandwich" },
  { name: "Pioneer Valley", center: [42.10, -72.59], homes: "Springfield · Northampton" },
];
